<template>
    <!-- Jssor Slider Begin -->
    <div ref="sliderA" class="agx-container ags-slider-wrapper">
        <!-- Slides Container -->
        <div u="slides" class="slideContainerDiv"
            style="cursor: move; position: absolute; left: 0px; top: 0px; width: 600px; height:700px; overflow: hidden;">
        </div>
        <!-- <div u="navigator" class="jssorb13" style="bottom: 16px; right: 10px;">
            <div u="prototype"></div>
        </div> -->
        <!-- <div u="navigator" class="jssorb02" style="bottom: 16px; left: 6px;">
            <div u="prototype"></div>
        </div> -->

        <!-- Arrow Navigator -->

        <div data-u="arrowleft" class="jssora051" style="width:55px;height:55px;top:0px;left:25px;" data-autocenter="2"
            data-scale="0.75" data-scale-left="0.75">
            <svg viewBox="0 0 16000 16000" style="position:absolute;top:0;left:0;width:100%;height:100%;">
                <polyline class="a" points="11040,1920 4960,8000 11040,14080 "></polyline>
            </svg>
        </div>
        <div data-u="arrowright" class="jssora051" style="width:55px;height:55px;top:0px;right:25px;"
            data-autocenter="2" data-scale="0.75" data-scale-right="0.75">
            <svg viewBox="0 0 16000 16000" style="position:absolute;top:0;left:0;width:100%;height:100%;">
                <polyline class="a" points="4960,1920 11040,8000 4960,14080 "></polyline>
            </svg>
        </div>

    </div>
    <!-- Jssor Slider End -->
</template>
<script>

export default {
    props: {
        sliderData: []
    },
    data: function () {
        return {
            jdrInst: null
        };
    },
    methods: {
        genSlider: function () {
            // Code that will run only after the
            // entire view has been re-rendered
            if (this.sliderData.length > 0 && !this.sliderLoaded) {
                this.sliderLoaded = true;
                this.jdrInst = jdr.ScaleSlider.genLinkedBanner(this.sliderData, this.$refs.sliderA);
            }
        }
    },
    mounted: function () {
        this.genSlider();
    },
    destroyed: function () {
        if (this.jdrInst !== null) {
            this.jdrInst.destroy();
        }
    }
}
</script>